/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CreateSeasonResponse } from './CreateSeasonResponse';
import {
    CreateSeasonResponseFromJSON,
    CreateSeasonResponseFromJSONTyped,
    CreateSeasonResponseToJSON,
    CreateSeasonResponseToJSONTyped,
} from './CreateSeasonResponse';

/**
 * 
 * @export
 * @interface ResultOfCreateSeasonResponse
 */
export interface ResultOfCreateSeasonResponse {
    /**
     * 
     * @type {CreateSeasonResponse}
     * @memberof ResultOfCreateSeasonResponse
     */
    data: CreateSeasonResponse | null;
    /**
     * 
     * @type {boolean}
     * @memberof ResultOfCreateSeasonResponse
     */
    isSuccess: boolean;
    /**
     * 
     * @type {Error}
     * @memberof ResultOfCreateSeasonResponse
     */
    error: Error | null;
}

/**
 * Check if a given object implements the ResultOfCreateSeasonResponse interface.
 */
export function instanceOfResultOfCreateSeasonResponse(value: object): value is ResultOfCreateSeasonResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('isSuccess' in value) || value['isSuccess'] === undefined) return false;
    if (!('error' in value) || value['error'] === undefined) return false;
    return true;
}

export function ResultOfCreateSeasonResponseFromJSON(json: any): ResultOfCreateSeasonResponse {
    return ResultOfCreateSeasonResponseFromJSONTyped(json, false);
}

export function ResultOfCreateSeasonResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResultOfCreateSeasonResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': CreateSeasonResponseFromJSON(json['data']),
        'isSuccess': json['isSuccess'],
        'error': json['error'],
    };
}

export function ResultOfCreateSeasonResponseToJSON(json: any): ResultOfCreateSeasonResponse {
    return ResultOfCreateSeasonResponseToJSONTyped(json, false);
}

export function ResultOfCreateSeasonResponseToJSONTyped(value?: ResultOfCreateSeasonResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': CreateSeasonResponseToJSON(value['data']),
        'isSuccess': value['isSuccess'],
        'error': value['error'],
    };
}

